export { Slider } from './Slider';
export type { Props } from './Slider.types';
